import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { CACHE_EXPIRY } from '../cache/imageCache';

const ImageCacheContext = createContext();
export const useImageCache = () => useContext(ImageCacheContext);

export const ImageCacheProvider = ({ children }) => {
  const [cacheClearCount, setCacheClearCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (document.visibilityState === 'visible') {
        setCacheClearCount(prev => prev + 1);
      }
    }, CACHE_EXPIRY);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        caches.delete('image-cache-v1').then(() => {
          setCacheClearCount(prev => prev + 1);
        });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  const clearCache = useCallback(() => {
    caches.delete('image-cache-v1').then(() => {
      setCacheClearCount(prev => prev + 1);
    });
  }, []);

  return (
      <ImageCacheContext.Provider value={{ cacheClearCount, clearCache }}>
        {children}
      </ImageCacheContext.Provider>
  );
};